import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBlog } from "../SpiderWebSite/Blog/interface";
import { ITypeMaj } from "../SpiderWebSite/MajSpider/interface";

export interface ISiteWebState {
  actualites: IActualite[];
  filteredActualites: IActualite[];

  flashInfos: IFlashInfo[];
  filteredFlashInfos: IFlashInfo[];

  bannieres: IBanniere[];
  filteredBannieres: IBanniere[];

  services: IService[];
  filteredServices: IService[];

  fonctions: IFonction[];
  filteredFonctions: IFonction[];

  contacts: IContact[];
  filteredContacts: IContact[];

  agents: IAgent[];
  filteredAgents: IAgent[];

  applications: IApplication[];
  filteredApplications: IApplication[];

  majSpiders: IMajSpider[];
  filteredMajSpiders: IMajSpider[];

  etablissements: IEtablissement[];
  filteredEtablissements: IEtablissement[];

  categories: ICategorie[];

  blogs: IBlog[];
  filteredBlogs: IBlog[];
  typeMaj: ITypeMaj[];
  allSpiderApp: ISpiderApp[];
}

export interface IActualite {
  idActualite: number;
  idCategorie?: number;
  titre: string;
  sousTitre: string;
  texteComplet: string;
  actualiteImage: string;
  dateActualite: string;
  idDossier?: number;
  active: number;
  aLaUne: number;
}

export interface IFlashInfo {
  idInfo?: number;
  titreInfo?: string;
  active?: number;
}

export interface IService {
  idService?: number;
  libService?: string;
}

export interface IFonction {
  idFonction?: number;
  fonctionAgent?: string;
}

export interface IContact {
  idContact?: number;
  libContact?: string;
  numero: string;
}

export interface IAgent {
  idAgent: number,
  nomAgent: string,
  idFonction: number,
  idService: number,
  photoAgent: string,
  agentImageEnBase64: string
}

export interface IBanniere {
  idBanniere: number;
  libBanniere?: string;
  active?: number;
}

export interface IApplication {
  idApp?: number;
  libApp: string;
  descriptionApp: string;
  logoAppEnBase64: string;
  logoApp?: string;
  texteComplet: string;
  checkListe: any;
  idAppImage?: number;
  libAppImage?: string;
  appImagesEnBase64: string[];
  lienPlaystore: string;
  lienAppStore: string;
}

export interface IMajSpider {
  idSpiderVersion: number,
  versionNumber: string,
  VersionDescriptionArray: any,
  versionFileLocation?: string,
  versionDate: string,
  spiderVersionExeEnBase64: string
}

export interface IEtablissement {
  idEtab: number,
  libEtab: string,
  logoEtabEnbase64: string | undefined | unknown
  libImageEtab: string,
}

export interface ISpiderApp {
  idApp: number;
  libApp: string;
  descriptionApp: string;
  logoApp: string;
  checkListe: string;
  paragrapheListe: string;
  texteComplet: string;
  active: number;
  idAppImage: number;
  libAppImage: string;
  lienApp: string;
  lienPlaystore: string;
  lienAppStore: string;
}



// export interface IBlog {
//   idBlog: number;
//   idCategorie: number;
//   titre: string;
//   sousTitre: string;
//   texteComplet: string;
//   imageBlog: string;
//   dateBlog: string;
//   active: number;
// }

export interface IActualite {
  idBlog: number;
  titre: string;
  sousTitre: string;
  texteComplet: string;
  imageBlog: string;
  dateBlog: string;
  active: number;
}

export interface ICategorie {
  idCategorie: number;
  libCategorie: string;
}


const initialState: ISiteWebState = {
  actualites: [],
  filteredActualites: [],
  flashInfos: [],
  filteredFlashInfos: [],
  bannieres: [],
  filteredBannieres: [],
  services: [],
  filteredServices: [],
  fonctions: [],
  filteredFonctions: [],
  contacts: [],
  filteredContacts: [],
  agents: [],
  filteredAgents: [],
  applications: [],
  filteredApplications: [],
  majSpiders: [],
  filteredMajSpiders: [],
  etablissements: [],
  filteredEtablissements: [],
  categories: [],
  blogs: [],
  filteredBlogs: [],
  typeMaj: [],
  allSpiderApp: [],
}

export const siteWebSlice: any = createSlice({
  name: "siteWebSlice",
  initialState: initialState,
  reducers: {


    //debut   actualité 

    addActualite: (state, action: PayloadAction<IActualite>) => {
      state.actualites.unshift(action.payload);
      state.filteredActualites.unshift(action.payload);
    },

    setActualites: (state, action: PayloadAction<IActualite[]>) => {
      state.actualites = action.payload;
    },
    setFilteredActualites: (state, action: PayloadAction<IActualite[]>) => {
      state.filteredActualites = action.payload;
    },

    updateActualite: (state, action: PayloadAction<IActualite>) => {
      const newActualites = state.actualites.map((i: IActualite) =>
        i.idActualite === action.payload.idActualite
          ? action.payload
          : i
      );
      const newFilteredActualites = state.filteredActualites.map(
        (i: IActualite) =>
          i.idActualite === action.payload.idActualite
            ? action.payload
            : i
      );
      state.actualites = newActualites;
      state.filteredActualites = newFilteredActualites;
    },


    deleteActualite: (state, action: PayloadAction<{ idActualite: number }>) => {
      state.actualites = state.actualites.filter((actualite: IActualite) => actualite.idActualite !== action.payload.idActualite);
      state.filteredActualites = state.filteredActualites.filter((actualite: IActualite) => actualite.idActualite !== action.payload.idActualite);
    },
    // fin actualité //


    // debut flash info //
    addFlashInfo: (state, action: PayloadAction<IFlashInfo>) => {
      state.flashInfos.unshift(action.payload);
      state.filteredFlashInfos.unshift(action.payload);
    },

    setFlashInfo: (state, action: PayloadAction<IFlashInfo[]>) => {
      state.flashInfos = action.payload;
    },
    setFilteredFlashInfo: (state, action: PayloadAction<IFlashInfo[]>) => {
      state.filteredFlashInfos = action.payload;
    },

    deleteFlashInfo: (state, action: PayloadAction<{ idInfo: number }>) => {
      state.flashInfos = state.flashInfos.filter((item: IFlashInfo) => item.idInfo !== action.payload.idInfo);
      state.filteredFlashInfos = state.filteredFlashInfos.filter((item: IFlashInfo) => item.idInfo !== action.payload.idInfo);
    },

    updateFlashInfo: (state, action: PayloadAction<IFlashInfo>) => {
      const newData = state.flashInfos.map((i: IFlashInfo) =>
        i.idInfo === action.payload.idInfo
          ? action.payload
          : i
      );
      const newFiltered = state.filteredFlashInfos.map(
        (i: IFlashInfo) =>
          i.idInfo === action.payload.idInfo
            ? action.payload
            : i
      );
      state.flashInfos = newData;
      state.filteredFlashInfos = newFiltered;
    },




    // debut Banniere //
    addBanniere: (state, action: PayloadAction<IBanniere>) => {
      state.bannieres.unshift(action.payload);
      state.filteredBannieres.unshift(action.payload);
    },

    setBanniere: (state, action: PayloadAction<IBanniere[]>) => {
      state.bannieres = action.payload;
    },
    setFilteredBanniere: (state, action: PayloadAction<IBanniere[]>) => {
      state.filteredBannieres = action.payload;
    },

    deleteBanniere: (state, action: PayloadAction<{ idBanniere: number }>) => {
      state.bannieres = state.bannieres.filter((item: IBanniere) => item.idBanniere !== action.payload.idBanniere);
      state.filteredBannieres = state.filteredBannieres.filter((item: IBanniere) => item.idBanniere !== action.payload.idBanniere);
    },

    updateBanniere: (state, action: PayloadAction<IBanniere>) => {
      const newData = state.bannieres.map((i: IBanniere) =>
        i.idBanniere === action.payload.idBanniere
          ? action.payload
          : i
      );
      const newFiltered = state.filteredBannieres.map(
        (i: IBanniere) =>
          i.idBanniere === action.payload.idBanniere
            ? action.payload
            : i
      );
      state.bannieres = newData;
      state.filteredBannieres = newFiltered;
    },

    // fin banniere 


    // debut service //
    addService: (state, action: PayloadAction<IService>) => {
      state.services.unshift(action.payload);
      state.filteredServices.unshift(action.payload);
    },

    setService: (state, action: PayloadAction<IService[]>) => {
      state.services = action.payload;
    },
    setFilteredService: (state, action: PayloadAction<IService[]>) => {
      state.filteredServices = action.payload;
    },

    deleteService: (state, action: PayloadAction<{ idService: number }>) => {
      state.services = state.services.filter((item: IService) => item.idService !== action.payload.idService);
      state.filteredServices = state.filteredServices.filter((item: IService) => item.idService !== action.payload.idService);
    },

    updateService: (state, action: PayloadAction<IService>) => {
      const newData = state.services.map((i: IService) =>
        i.idService === action.payload.idService
          ? action.payload
          : i
      );
      const newFiltered = state.filteredServices.map(
        (i: IService) =>
          i.idService === action.payload.idService
            ? action.payload
            : i
      );
      state.services = newData;
      state.filteredServices = newFiltered;
    },

    // fin service 



    // debut fonction //
    addFonction: (state, action: PayloadAction<IFonction>) => {
      state.fonctions.unshift(action.payload);
      state.filteredFonctions.unshift(action.payload);
    },

    setFonction: (state, action: PayloadAction<IFonction[]>) => {
      state.fonctions = action.payload;
    },
    setFilteredFonction: (state, action: PayloadAction<IFonction[]>) => {
      state.filteredFonctions = action.payload;
    },

    deleteFonction: (state, action: PayloadAction<{ idFonction: number }>) => {
      state.fonctions = state.fonctions.filter((item: IFonction) => item.idFonction !== action.payload.idFonction);
      state.filteredFonctions = state.filteredFonctions.filter((item: IFonction) => item.idFonction !== action.payload.idFonction);
    },

    updateFonction: (state, action: PayloadAction<IFonction>) => {
      const newData = state.fonctions.map((i: IFonction) =>
        i.idFonction === action.payload.idFonction
          ? action.payload
          : i
      );
      const newFiltered = state.filteredFonctions.map(
        (i: IFonction) =>
          i.idFonction === action.payload.idFonction
            ? action.payload
            : i
      );
      state.fonctions = newData;
      state.filteredFonctions = newFiltered;
    },
    // fin fonction 



    // debut contact //
    addContact: (state, action: PayloadAction<IContact>) => {
      state.contacts.unshift(action.payload);
      state.filteredContacts.unshift(action.payload);
    },

    setContact: (state, action: PayloadAction<IContact[]>) => {
      state.contacts = action.payload;
    },
    setFilteredContact: (state, action: PayloadAction<IContact[]>) => {
      state.filteredContacts = action.payload;
    },

    deleteContact: (state, action: PayloadAction<{ idContact: number }>) => {
      state.contacts = state.contacts.filter((item: IContact) => item.idContact !== action.payload.idContact);
      state.filteredContacts = state.filteredContacts.filter((item: IContact) => item.idContact !== action.payload.idContact);
    },

    updateContact: (state, action: PayloadAction<IContact>) => {
      const newData = state.contacts.map((i: IContact) =>
        i.idContact === action.payload.idContact
          ? action.payload
          : i
      );
      const newFiltered = state.filteredContacts.map(
        (i: IContact) =>
          i.idContact === action.payload.idContact
            ? action.payload
            : i
      );
      state.contacts = newData;
      state.filteredContacts = newFiltered;
    },
    // fin contact 


    // debut agent //
    addAgent: (state, action: PayloadAction<IAgent>) => {
      state.agents.unshift(action.payload);
      state.filteredAgents.unshift(action.payload);
    },

    setAgent: (state, action: PayloadAction<IAgent[]>) => {
      state.agents = action.payload;
    },
    setFilteredAgent: (state, action: PayloadAction<IAgent[]>) => {
      state.filteredAgents = action.payload;
    },

    deleteAgent: (state, action: PayloadAction<{ idAgent: number }>) => {
      state.agents = state.agents.filter((item: IAgent) => item.idAgent !== action.payload.idAgent);
      state.filteredAgents = state.filteredAgents.filter((item: IAgent) => item.idAgent !== action.payload.idAgent);
    },

    updateAgent: (state, action: PayloadAction<IAgent>) => {
      const newData = state.agents.map((i: IAgent) =>
        i.idAgent === action.payload.idAgent
          ? action.payload
          : i
      );
      const newFiltered = state.filteredAgents.map(
        (i: IAgent) =>
          i.idAgent === action.payload.idAgent
            ? action.payload
            : i
      );
      state.agents = newData;
      state.filteredAgents = newFiltered;
    },
    // fin agent 



    // debut application //
    addApplication: (state, action: PayloadAction<IApplication[]>) => {
      state.applications = [...state.applications, ...action.payload];
      state.filteredApplications = [...state.applications, ...action.payload];
    },

    setApplication: (state, action: PayloadAction<IApplication[]>) => {
      state.applications = action.payload;
    },
    setFilteredApplication: (state, action: PayloadAction<IApplication[]>) => {
      state.filteredApplications = action.payload;
    },

    deleteApplication: (state, action: PayloadAction<{ idApp: number }>) => {
      state.applications = state.applications.filter((item: IApplication) => item.idApp !== action.payload.idApp);
      state.filteredApplications = state.filteredApplications.filter((item: IApplication) => item.idApp !== action.payload.idApp);
    },

    updateApplication: (state, action: PayloadAction<IApplication>) => {
      const newData = state.applications.map((i: IApplication) =>
        i.idApp === action.payload.idApp
          ? action.payload
          : i
      );
      const newFiltered = state.filteredApplications.map(
        (i: IApplication) =>
          i.idApp === action.payload.idApp
            ? action.payload
            : i
      );
      state.applications = newData;
      state.filteredApplications = newFiltered;
    },
    // fin application 



    // debut majSpider //
    addMajSpider: (state, action: PayloadAction<IMajSpider>) => {
      state.majSpiders.unshift(action.payload);
      state.filteredMajSpiders.unshift(action.payload);
    },


    setMajSpider: (state, action: PayloadAction<IMajSpider[]>) => {
      state.majSpiders = action.payload;
    },
    setFilteredMajSpider: (state, action: PayloadAction<IMajSpider[]>) => {
      state.filteredMajSpiders = action.payload;
    },

    deleteMajSpider: (state, action: PayloadAction<{ idSpiderVersion: number }>) => {
      state.majSpiders = state.majSpiders.filter((item: IMajSpider) => item.idSpiderVersion !== action.payload.idSpiderVersion);
      state.filteredMajSpiders = state.filteredMajSpiders.filter((item: IMajSpider) => item.idSpiderVersion !== action.payload.idSpiderVersion);
    },

    updateMajSpider: (state, action: PayloadAction<IMajSpider>) => {
      const newData = state.majSpiders.map((i: IMajSpider) =>
        i.idSpiderVersion === action.payload.idSpiderVersion
          ? action.payload
          : i
      );
      const newFiltered = state.filteredMajSpiders.map(
        (i: IMajSpider) =>
          i.idSpiderVersion === action.payload.idSpiderVersion
            ? action.payload
            : i
      );
      state.majSpiders = newData;
      state.filteredMajSpiders = newFiltered;
    },
    // fin majSpider 




    // debut Etablissement //
    addEtablissement: (state, action: PayloadAction<IEtablissement>) => {
      state.etablissements.unshift(action.payload);
      state.filteredEtablissements.unshift(action.payload);
    },

    setEtablissement: (state, action: PayloadAction<IEtablissement[]>) => {
      state.etablissements = action.payload;
    },

    setFilteredEtablissement: (state, action: PayloadAction<IEtablissement[]>) => {
      state.filteredEtablissements = action.payload;
    },

    deleteEtablissement: (state, action: PayloadAction<{ idEtab: number }>) => {
      state.etablissements = state.etablissements.filter((item: IEtablissement) => item.idEtab !== action.payload.idEtab);
      state.filteredEtablissements = state.filteredEtablissements.filter((item: IEtablissement) => item.idEtab !== action.payload.idEtab);
    },

    updateEtablissement: (state, action: PayloadAction<IEtablissement>) => {
      const newData = state.etablissements.map((i: IEtablissement) =>
        i.idEtab === action.payload.idEtab
          ? action.payload
          : i
      );
      const newFiltered = state.filteredEtablissements.map(
        (i: IEtablissement) =>
          i.idEtab === action.payload.idEtab
            ? action.payload
            : i
      );
      state.etablissements = newData;
      state.filteredEtablissements = newFiltered;
    },
    // fin Etablissement 


    //debut categorie
    setCategorie: (state, action: PayloadAction<ICategorie[]>) => {
      state.categories = action.payload;
    },

    addCategorie: (state, action: PayloadAction<ICategorie>) => {
      state.categories.unshift(action.payload);

    },

    deleteCategorie: (state, action: PayloadAction<{ idCategorie: number }>) => {
      state.categories = state.categories.filter((item: ICategorie) => item.idCategorie !== action.payload.idCategorie);
    },
    //Fin categorie





    //BLOG

    addBlog: (state, action: PayloadAction<IBlog>) => {
      state.blogs.unshift(action.payload);
      state.filteredBlogs.unshift(action.payload);
    },

    setBlogs: (state, action: PayloadAction<IBlog[]>) => {
      state.blogs = action.payload;
    },

    setFilteredBlogs: (state, action: PayloadAction<IBlog[]>) => {
      state.filteredBlogs = action.payload;
    },

    updateBlog: (state, action: PayloadAction<IBlog>) => {
      const newBlogs = state.blogs.map((i: IBlog) =>
        i.idBlog === action.payload.idBlog
          ? action.payload
          : i
      );
      const newFilteredBlogs = state.filteredBlogs.map(
        (i: IBlog) =>
          i.idBlog === action.payload.idBlog
            ? action.payload
            : i
      );
      state.blogs = newBlogs;
      state.filteredBlogs = newFilteredBlogs;
    },


    deleteBlog: (state, action: PayloadAction<{ idBlog: number }>) => {
      state.blogs = state.blogs.filter((blog: IBlog) => blog.idBlog !== action.payload.idBlog);
      state.filteredBlogs = state.filteredBlogs.filter((blog: IBlog) => blog.idBlog !== action.payload.idBlog);
    },

    setTypeMaj: (state, action: PayloadAction<ITypeMaj[]>) => {
      state.typeMaj = action.payload;
    },

    setAllSpiderApp: (state, action: PayloadAction<ISpiderApp[]>) => {
      state.allSpiderApp = action.payload;
  },

  },
});

export const {
  addBlog,
  setBlogs,
  setFilteredBlogs,
  updateBlog,
  deleteBlog,

  deleteCategorie,
  addCategorie,
  setCategorie,
  updateEtablissement,
  deleteEtablissement,
  setFilteredEtablissement,
  setEtablissement,
  addEtablissement,
  updateMajSpider,
  deleteMajSpider,
  setFilteredMajSpider,
  setMajSpider,
  addMajSpider,
  updateApplication,
  deleteApplication,
  setFilteredApplication,
  setApplication,
  addApplication,
  updateAgent,
  deleteAgent,
  setFilteredAgent,
  setAgent,
  addAgent,
  updateContact,
  deleteContact,
  setFilteredContact,
  setContact,
  addContact,
  updateFonction,
  deleteFonction,
  setFilteredFonction,
  setFonction,
  addFonction,
  updateService,
  deleteService,
  setFilteredService,
  setService,
  addService,
  addBanniere,
  setBanniere,
  setFilteredBanniere,
  deleteBanniere,
  updateBanniere,
  updateFlashInfo,
  deleteFlashInfo,
  setFlashInfo,
  setFilteredFlashInfo,
  addFlashInfo,
  addActualite,
  deleteActualite,
  setActualites,
  setFilteredActualites,
  updateActualite,
  setTypeMaj,
  setAllSpiderApp
} = siteWebSlice.actions;

export default siteWebSlice.reducer;
